<template>
  <div class="contracts-content">
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      id="modal-add-care-add"
      title="ADICIONAR CUIDADO NA PRESCRIÇÃO"
    >
      <div v-if="step == 1" class="col-md-12">
        <LabelRequiredField label="Tipo de Agendamento" />

        <v-select
          v-model="care"
          :items="cares"
          item-text="name"
          :return-object="true"
          clearable
          outlined
          class="modern-select"
          placeholder="Selecione o Cuidado"
        />

        <div v-if="care.length != 0">
          <div class="row">
            <div class="mr-5">
              <LabelRequiredField label="Frequência" />

              <v-select
                :items="[
                  { text: 'DIÁRIO', value: 'DIARIO' },
                  { text: 'SEMANAL', value: 'SEMANAL' },
                  { text: 'EVENTUAL', value: 'EVENTUAL' },
                ]"
                v-model="frequency"
                item-text="text"
                item-value="value"
                outlined
                class="modern-select"
                placeholder="Selecione a frequência"
              />
            </div>

            <div class="mr-5">
              <LabelRequiredField label="Quantidade Diária" />

              <v-select
                :items="amountOfTimes"
                v-model="amountAtTime"
                item-text="name"
                :return-object="true"
                outlined
                class="modern-select"
                placeholder="Selecione a Quantidade Diária"
              />
            </div>
          </div>

          <div v-if="frequency == 'SEMANAL'" class="p-2">
            <v-btn
              :class="['v-no-border-radius', DOM ? 'v-primary' : '']"
              @click="DOM = !DOM"
            >
              DOM
            </v-btn>

            <v-btn
              :class="['v-no-border-radius', SEG ? 'v-primary' : '']"
              @click="SEG = !SEG"
            >
              SEG
            </v-btn>

            <v-btn
              :class="['v-no-border-radius', TER ? 'v-primary' : '']"
              @click="TER = !TER"
            >
              TER
            </v-btn>

            <v-btn
              :class="['v-no-border-radius', QUA ? 'v-primary' : '']"
              @click="QUA = !QUA"
            >
              QUA
            </v-btn>

            <v-btn
              :class="['v-no-border-radius', QUI ? 'v-primary' : '']"
              @click="QUI = !QUI"
            >
              QUI
            </v-btn>

            <v-btn
              :class="['v-no-border-radius', SEX ? 'v-primary' : '']"
              @click="SEX = !SEX"
            >
              SEX
            </v-btn>

            <v-btn
              :class="['v-no-border-radius', SAB ? 'v-primary' : '']"
              @click="SAB = !SAB"
            >
              SAB
            </v-btn>
          </div>

          <div
            v-if="frequency != 'EVENTUAL'"
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-center"
          >
            <label class="mb-0 day-width">A CADA</label>

            <input v-model="every" type="text" class="form-control" />

            <label class="mb-0 day-width pl-3">
              {{ frequency == "SEMANAL" ? "SEMANAS(S)" : "DIAS(S)" }}
            </label>
          </div>

          <div
            v-if="amountAtTime.type == 'SHIFTS'"
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          >
            <div class="row">
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
              >
                <vs-checkbox v-model="dawn">MADRUGADA</vs-checkbox>
              </div>
            </div>

            <hr />

            <div class="row">
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
              >
                <vs-checkbox v-model="morning">MANHÃ</vs-checkbox>
              </div>
            </div>

            <hr />

            <div class="row">
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
              >
                <vs-checkbox v-model="afternoon">TARDE</vs-checkbox>
              </div>
            </div>

            <hr />

            <div class="row">
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
              >
                <vs-checkbox v-model="night">NOITE</vs-checkbox>
              </div>
            </div>

            <hr />

            <!-- shift_5 -->
            <div class="row">
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
              >
                <vs-checkbox v-model="shift_5">5º</vs-checkbox>
              </div>
            </div>

            <hr />
            <!-- shift_6 -->
            <div class="row">
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
              >
                <vs-checkbox v-model="shift_6">6º</vs-checkbox>
              </div>
            </div>

            <hr />

            <!-- shift_7 -->
            <div class="row">
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
              >
                <vs-checkbox v-model="shift_7">7º</vs-checkbox>
              </div>
            </div>

            <hr />

            <!-- shift_8 -->
            <div class="row">
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
              >
                <vs-checkbox v-model="shift_8">8º</vs-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="text-right">
          <v-btn
            :disabled="care.length == 0"
            @click="handleNextStep"
            class="btn-save"
          >
            AVANÇAR

            <i class="ml-1 fas fa-arrow-right text-twenty"></i>
          </v-btn>
        </div>
      </div>

      <div v-if="step == 2" class="col-md-12">
        <div>
          <h6 class="text-fourteen">DURAÇÃO</h6>

          <div class="d-flex">
            <vs-radio
              class="col-md-4 pt-0 pb-0"
              v-model="duration"
              vs-value="CONTINUO"
              >CONTÍNUO</vs-radio
            >

            <vs-radio
              class="col-md-4 pt-0 pb-0"
              v-model="duration"
              vs-value="DURANTE_UM_PERIODO"
              >DURANTE UM PERÍODO</vs-radio
            >

            <vs-radio
              class="col-md-4 pt-0 pb-0"
              v-model="duration"
              vs-value="ATE_A_DATA"
              >ATÉ A DATA</vs-radio
            >
          </div>
        </div>

        <div class="row v-clean">
          <div v-if="duration == 'CONTINUO'" class="col-md-6">
            <h6 class="text-fourteen">INICIAR MEDICAMENTO</h6>

            <input v-model="init" type="date" class="form-control" />
          </div>

          <div
            v-if="duration == 'ATE_A_DATA' || duration == 'DURANTE_UM_PERIODO'"
            class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pt-1 pb-1"
          >
            <h6 class="text-fourteen">DATA DE INÍCIO</h6>
            <input v-model="start_date" type="date" class="form-control" />
          </div>

          <div
            v-if="duration == 'DURANTE_UM_PERIODO'"
            class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pt-1 pb-1"
          >
            <h6 class="text-fourteen">TEMPO DE DURAÇÃO</h6>

            <vs-slider :min="1" :max="30" v-model="duration_time" />

            <div class="d-flex justify-content-center align-items-center">
              <h3 class="c-primary mr-1">{{ duration_time }}</h3>
              dia(s)
            </div>
          </div>

          <div
            v-if="duration == 'ATE_A_DATA'"
            class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pt-1 pb-1"
          >
            <h6 class="text-fourteen">DATA DE TÉRMINO</h6>
            <input v-model="end_date" type="date" class="form-control" />
          </div>
        </div>

        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pl-3 pt-0 pb-0"
        >
          <h6 class="text-fourteen">INSTRUÇÃO</h6>
          <ChromeSpeechToTextTextarea
            rows="4"
            max-rows="10"
            v-model="instruction"
          />
        </div>

        <v-btn v-show="step != 0" @click="step = 1" class="btn-return">
          <i class="fas fa-arrow-left mr-2 text-twenty"></i>

          VOLTAR
        </v-btn>

        <div class="text-right">
          <v-btn @click="handleNextStep" class="btn-save">
            <i class="ml-1 fas fa-check text-twenty"></i>

            ADICIONAR
          </v-btn>
        </div>
      </div>

      <ErrorsMessages :errors="errors" />
    </b-modal>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import LabelRequiredField from "../../../templates/Components/LabelRequiredField";

import ChromeSpeechToTextTextarea from "../../../templates/Components/ChromeSpeechToTextTextarea";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

export default {
  name: "CareAdd",

  components: {
    ErrorsMessages,
    LabelRequiredField,
    ChromeSpeechToTextTextarea,
  },

  props: {
    resident_id: [String, Number],

    group_prescription_care: Object,
  },

  data() {
    return {
      loading: false,

      care: [],

      total: 0,

      every: 1,

      step: 1,

      frequency: "DIARIO",

      cares: [],

      amountOfTimes: [],

      amountAtTime: [],

      errors: [],

      DOM: false,
      SEG: false,
      TER: false,
      QUA: false,
      QUI: false,
      SEX: false,
      SAB: false,

      dawn: false,
      morning: false,
      afternoon: false,
      night: false,

      shift_5: false,
      shift_6: false,
      shift_7: false,
      shift_8: false,

      duration: "CONTINUO",
      init: "",
      start_date: "",
      end_date: "",
      duration_time: 1,
      instruction: "",
    };
  },

  async mounted() {
    await this.getCares();

    await this.getMedicineAmountOfTimes();
  },

  watch: {
    async resident_id() {
      await this.getCares();

      await this.getMedicineAmountOfTimes();
    },
  },

  methods: {
    async getCares() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/resident/group-prescription-cares/filter"
        );

        const { error, errors, cares, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          this.cares = cares;

          this.total = total;

          this.loading = false;
        }
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async getMedicineAmountOfTimes() {
      try {
        const response = await api.get("/admin/medicine-amount-of-times");

        const { error, errors, medicine_amount_of_times } = response.data;

        if (!error) {
          this.errors = [];

          this.amountOfTimes = medicine_amount_of_times;

          for (const item of medicine_amount_of_times) {
            if (item.name == "1x / DIA") {
              this.amountAtTime = item;
            }
          }
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async create() {
      try {
        this.loading = true;

        let {
          group_prescription_care, // -> OK
          care, //MEDICAMENTO // -> OK
          frequency, //FREQUÊNCIA // -> OK
          amountAtTime, //QUANTIDADE DIÁRIA
          every, //A CADA,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning, //MANHÃ
          afternoon, //TARDE
          night, //NOITE
          dawn, //MADRUGADA
          shift_5, //5
          shift_6, //6
          shift_7, //7
          shift_8, //8
          start_date, //DATA DE INÍCIO
          duration, //DURAÇÃO
          duration_time, //TEMPO DE DURAÇÃO
          end_date, //DATA DE TÉRMINO
          instruction, //INSTRUÇÃO
          init,
        } = this;

        let params = {
          group_prescription_care_id: group_prescription_care.id,
          resident_id: group_prescription_care.resident_id,
          care,
          name: care.name,
          frequency,
          care_amount_of_times_id: amountAtTime.id,
          type_care_amount_of_times_id: amountAtTime.type,
          every,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning,
          afternoon,
          night,
          dawn,
          shift_5,
          shift_6,
          shift_7,
          shift_8,
          start_date,
          duration,
          duration_time,
          end_date,
          instruction,
          init,
        };

        const response = await api.post("/rest-home/prescription-care", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("create");

          this.$bvModal.hide("modal-add-care-add");

          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleNextStep() {
      this.errors = [];

      let { step } = this;

      if (step == 1) {
        let {
          frequency,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning,
          afternoon,
          night,
          shift_5,
          shift_6,
          shift_7,
          shift_8,
          dawn,
          every,
        } = this;

        let care_amount_of_times_id = this.amountAtTime.id;

        let type_care_amount_of_times_id = this.amountAtTime.type;

        let SEMANAL = "SEMANAL";
        let EVENTUAL = "EVENTUAL";

        if (!String(frequency).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe frequência",
          });
        }

        if (!String(care_amount_of_times_id).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe quantidade diária",
          });
        }

        if (frequency != EVENTUAL) {
          if (frequency == SEMANAL) {
            if (!DOM && !SEG && !TER && !QUA && !QUI && !SEX && !SAB) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe ao menos um dia da semana",
              });
            }

            if (Number(every) < 1 || !Number(every)) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe o intervalo",
              });
            }
          }

          if (type_care_amount_of_times_id == "SHIFTS") {
            if (
              !morning &&
              !afternoon &&
              !night &&
              !dawn &&
              !shift_5 &&
              !shift_6 &&
              !shift_7 &&
              !shift_8
            ) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe ao menos um turno",
              });
            }
          }
        }

        if (this.errors.length > 0) {
          return;
        }

        this.step = 2;
      }

      if (step == 2) {
        let {
          frequency,
          duration,
          instruction,
          start_date,
          end_date,
          duration_time,
          init,
        } = this;

        const ATE_A_DATA = "ATE_A_DATA";

        const DURANTE_UM_PERIODO = "DURANTE_UM_PERIODO";

        if (duration == ATE_A_DATA) {
          if (frequency != "EVENTUAL") {
            if (!String(start_date).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe a data de início",
              });
            }
          }

          if (!String(end_date).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe data de término",
            });
          }
        }

        if (duration == DURANTE_UM_PERIODO) {
          if (frequency != "EVENTUAL") {
            if (!String(start_date).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe a data de início",
              });
            }
          }

          if (!String(duration_time).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe tempo de duração",
            });
          }
        }

        if (frequency == "EVENTUAL") {
          if (!String(instruction).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe instrução",
            });
          }
        }

        if (!init && duration == "CONTINUO") {
          this.errors.push({
            id: this.errors.length,
            message: "Informe a data que o medicamento irá iniciar",
          });
        }

        if (this.errors.length > 0) {
          return;
        }

        this.create();
      }
    },
  },
};
</script>